import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import * as actions from './actions'
import { api } from './api'
import { DealStatus } from 'constants/dealConstants'

import config from 'config'

const redirectToLogin = () => window.location.replace(`${config.START_WEB_URL}`)

const fetchDeal = action$ => {
  return action$
    .ofType(actions.fetchDeal.toString())
    .pluck('payload')
    .mergeMap(dealCode => {
      return Observable.fromPromise(api.fetchBillingDeal(dealCode))
        .map(deal => {
          if (deal.status === DealStatus.ACTIVATED) {
            redirectToLogin()
          }

          return actions.fetchDealSuccess(deal)
        })
        .startWith(actions.fetchDealPending())
        .catch(() => Observable.of(actions.fetchDealFailed()))
    })
}

const activateDeal = action$ => {
  return action$
    .ofType(actions.activateDeal.toString())
    .pluck('payload')
    .mergeMap(({ dealId, billingToken, accessToken }) => {
      return api.activateDeal({ dealId, billingToken, accessToken })
        .map((response) => actions.activateDealSuccess(response))
        .startWith(actions.activateDealPending())
        .catch((err) => Observable.of(actions.activateDealFailed(err)))
    })
}

export const epic = combineEpics(fetchDeal, activateDeal)



// WEBPACK FOOTER //
// ./src/modules/billing/epic.js